module.exports = __webpack_public_path__ + "static/media/image6.edf199a1.jpg";